module.exports = __webpack_public_path__ + "assets/img/triple_half.68838de2.svg";